/**
 * List of key used for dashboard monitoring sheet columns values
 *
 * @export
 * @enum {number}
 */
export enum DashboardMonitoringSheetColumnKeys {
    FREQUENCY = "frequency",
    DECISION_PERIMETER = "decisionPerimeterGuid",
    END_DATE = 'endDate',
    ACTION = 'action'
}